import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=5579c49e"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5579c49e')) {
      api.createRecord('5579c49e', component.options)
    } else {
      api.reload('5579c49e', component.options)
    }
    module.hot.accept("./Info.vue?vue&type=template&id=5579c49e", function () {
      api.rerender('5579c49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/Info.vue"
export default component.exports